export const CANCEL_SOURCES = {
  RECORDS_FILTER: 'records-filter',
  PRODUCTS_FILTER: 'products-filter',
  PRODUCTS_VIEWS: 'products-views',
  AI_CHAT_RECORD_LIST: 'ai-chat-record-list',
  AI_CHAT_COMPANY_LIST: 'ai-chat-company-list',
  AI_CHAT_MESSAGES: 'ai-chat-messages',
  AI_CHAT_ATTACHMENTS: 'ai-chat-attachments',
  AI_CHAT_UPLOAD: 'ai-chat-upload',
  MENTION_SEARCH: 'mention-search',
} as const

export type CancelSource = typeof CANCEL_SOURCES[keyof typeof CANCEL_SOURCES]
